var _path;
import * as React from "react";
function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 31c0 2.757-2.243 5-5 5s-5-2.243-5-5 2.243-5 5-5 5 2.243 5 5zM15.579 5.575l.85 17A1.5 1.5 0 0017.927 24h4.146a1.5 1.5 0 001.498-1.425l.85-17A1.5 1.5 0 0022.923 4h-5.846a1.5 1.5 0 00-1.498 1.575z"
  })));
}
export default SvgExclamation;